var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"daily-list","label":"报表任务列表"}}),(_vm.$route.name === 'daily-form')?_c('ElTabPane',{attrs:{"name":"daily-form","label":"新建报表任务"}}):_vm._e(),(_vm.$route.name === 'daily-task-records')?_c('ElTabPane',{attrs:{"name":"daily-task-records","label":"发送任务记录"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }